export function shortenUUID(uuid: string) {
  return uuid.slice(0, 4);
}
